import { Component, EventEmitter, Input, Output, DoCheck } from '@angular/core';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../common/global-variables';
import { ICCService } from '../icc.service';

@Component({
  selector: 'add-network',
  styles: [require('../icc.scss')],
  template: require('./add-network.html'),
    providers: [
      TranslateService
  ]
})
export class AddNetwork {
    @Input() fleetConfig: any;
    @Input() showAddNetworkDialog: boolean = false;

    private isTranslationready: boolean = true;
    private backingList: Array<Object>;
    private isLoading: boolean = false;
    private isDataReady: boolean = false;
    private fleetConfigList: any;
    private network: any;
    private dataModel: any;
    private showForm: boolean = false;
    private resourceId: string = '';
    private isFormValid: boolean = true;

 constructor(private translate: TranslateService,  public service: ICCService,) {
    translate.use(GlobalVariables.LOCALE);
  }

  ngOnInit() {
      this.isDataReady = false;
  }


  ngOnChanges() {
      if (this.fleetConfig) {
          this.resourceId = this.fleetConfig.resourceId;
          this.getNetworkBackings(this.resourceId);
            // // this.getNetworkBackings(this.selectedResourceDetails.resourceId)
            // this.fleetConfigList = this.selectedResourceDetails.fleetConfigList;
            // this.dataModel =  this.selectedResourceDetails.networkDetails;
            // this.dataModel.networkName = this.selectedResourceDetails.networkName;
            // this.showForm = true;
            // console.log ('this.dataModel')
            // console.log (this.dataModel)
      }
  }

  checkFormValid() {

  }

  getNetworkBackings(resourceId) {
    this.backingList = [];
    this.service.getNetworkBackings(resourceId)
        .subscribe(
            (data:any) => {
                this.backingList = data;
                this.isDataReady = true;
            },
            error => {
                console.log ("Error backing")
                this.isLoading = false;
                this.isDataReady = false;
            }
        );
  }

  setNetworkProfiles(event) {
        this.isFormValid = !event.isGlobalValid
  }

    onAddNetworkDialogCancel() {
        this.showAddNetworkDialog = false;
    }
    onAddNetworkDialogSave() {
        this.showAddNetworkDialog = false;

    }
}



// WEBPACK FOOTER //
// ./src/app/components/administration-main/interconnect-configuration/dialog/add-network.component.ts